import React, {useState} from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

function FilterOrder({ filterValueSelected, options }) {
    const [selectedItem, setSelectedItem] = useState("Всі");

    const onFilterValueChanged = (eventKey) => {
        filterValueSelected(eventKey);
        setSelectedItem(eventKey === "all" ? "Всі" : eventKey);
    };

    return (
        <Dropdown onSelect={onFilterValueChanged}>
            <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                {selectedItem ? selectedItem : "Sources"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {selectedItem !== "Всі" ? (
                    <Dropdown.Item eventKey="all">Всі</Dropdown.Item>
                ) : null}
                {options.map((option, i) => (
                    <Dropdown.Item key={String(option) + i} eventKey={option}>
                        {option}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default FilterOrder;